const VueFileUploader = {
    // eslint-disable-next-line
    install: function (Vue, options) {
        const fileuploader = window['$fileuploader'];

        Vue.prototype.$fileuploader = fileuploader
    }
}

export default VueFileUploader
